// removed by extract-text-webpack-plugin
module.exports = {"image-container":"src-components-SingleClient-topBlock-___topBlock__image-container___tWdTF","client-title":"src-components-SingleClient-topBlock-___topBlock__client-title___2IJH4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleClient/topBlock/topBlock.css
// module id = 1077
// module chunks = 0